import {fetchDelete, fetchPatch, fetchPost, generateEndpoint} from "../../../utils/request";

export const updateMedicalOrganization = async({token, medicalOrganization}) => {
  const url = `${generateEndpoint("updateMedicalOrganization")}`;
  return fetchPatch(url, token, {medicalOrganization});
};

export const createMedicalOrganization = async({token, medicalOrganization}) => {
  const url = `${generateEndpoint("createMedicalOrganization")}`;
  return fetchPost(url, token, {medicalOrganization});
};

export const deleteMedicalOrganization = async({token, id}) => {
  const url = `${generateEndpoint("deleteMedicalOrganization")}`;
  return fetchDelete(url, token, {id});
};
